import Storage from '../../storage';
import { apiGet, apiPost } from '../_common';

const API_ADDRESS = process.env.VUE_APP_API_ADDRESS;

export default {
  // month as YYYY-MM
  totals(month) {
    return apiGet('/magenta/fiscal/purchase-cost-report/totals', { month }).then(result => result.response);
  },
  recalculate(month) {
    const query = new URLSearchParams({ month }).toString();
    return apiPost(`/magenta/fiscal/purchase-cost-report/recalculate?${query}`, {}).then(result => result.response);
  },
  async download(month) {
    const query = new URLSearchParams({ month }).toString();
    const response = await fetch(`${API_ADDRESS}/magenta/fiscal/purchase-cost-report?${query}`, {
      headers: {
        Authorization: `Bearer ${Storage.get(Storage.keys.auth.token)}`,
      },
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `Falha ao exportar as compras do mês (HTTP ${response.status}).`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `compras-${month}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  },
};
